import { Button, Form, InputNumber, QRCode } from "antd"
import { useState } from "react";
import { createConsumableBonus } from "../../../api/transport/common";
import { FCRodinaButton } from "../../../components/Button";

interface FormValues {
    purchaseAmount: number;
}

export const CreateOfflinePurchaseBonusPage = () => {
    const [form] = Form.useForm<FormValues>();
    const [formComplete, setFormComplete] = useState(false);
    const [qrValue, setQrValue] = useState('');

    const onFormFinish = (values: FormValues) => {
        createConsumableBonus(values.purchaseAmount).then(data => {
            const qrToSet = `type=offlinePurchase;uuid=${data.uuid}`;
            setQrValue(qrToSet);
        });
    }

    return (
        <div className="w-full h-screen flex flex-col items-center justify-center text-5xl p-4 gap-2">
            {qrValue && <>
            <div className="font-bold text-xl p-8">Отсканируй приложением Родные</div>
                <QRCode value={qrValue} size={320} />
                <FCRodinaButton onClick={() => {
                    setQrValue('');
                    form.resetFields();
                    form.focusField('purchaseAmount');
                }}
                    size="xl"
                >Новый</FCRodinaButton>
            </>}
            <Form
                form={form}
                size="large"
                wrapperCol={{
                    span: 24
                }}
                labelCol={{
                    span: 0,
                }}
                className="w-full text-center"
                onFinish={onFormFinish}
                hidden={!!qrValue}
            >
                <Form.Item
                    name="purchaseAmount"
                    rules={[{
                        required: true,
                        message: 'Введите сумму'
                    }]}

                >
                    <InputNumber
                        className="w-full text-5xl text-center font-bold"
                        min={100}
                    />
                </Form.Item>
                <Form.Item
                    label=" "
                    colon={false}
                >
                    <Button htmlType="submit">Сохранить</Button>
                </Form.Item>
            </Form >
        </div>
    )
}